// pages/ConditionsGeneralesPage.jsx
// Page des conditions générales d'utilisation pour vocaverb.com

import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConditionsGeneralesPage.css';

export default function ConditionsGeneralesPage() {
  const { t } = useTranslation();

  return (
    <div className="cgu-page">
      <div className="cgu-container">
        <header className="cgu-header">
          <h1 className="cgu-title">{t('cgu.title')}</h1>
          <p className="cgu-subtitle">{t('cgu.subtitle')}</p>
        </header>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch1Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch1P1')}</p>
            <p>{t('cgu.ch1P2')}</p>
            <p>{t('cgu.ch1P3')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch2Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch2Intro')}</p>
            <ul>
              <li>{t('cgu.ch2Li1')}</li>
              <li>{t('cgu.ch2Li2')}</li>
              <li>{t('cgu.ch2Li3')}</li>
              <li>{t('cgu.ch2Li4')}</li>
              <li>{t('cgu.ch2Li5')}</li>
            </ul>
            <p>
              {t('cgu.ch2ServiceAccessible')}{' '}
              <a href="https://vocaverb.com" target="_blank" rel="noopener noreferrer">
                https://vocaverb.com
              </a>
              .
            </p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch3Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch3Intro')}</p>
            <ul>
              <li>{t('cgu.ch3Li1')}</li>
              <li>{t('cgu.ch3Li2')}</li>
              <li>{t('cgu.ch3Li3')}</li>
            </ul>
            <p>{t('cgu.ch3P1')}</p>
            <p>{t('cgu.ch3P2')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch4Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch4Intro')}</p>
            <ul>
              <li>
                <strong>{t('cgu.ch4Li1Label')}</strong> {t('cgu.ch4Li1Text')}
              </li>
              <li>
                <strong>{t('cgu.ch4Li2Label')}</strong> {t('cgu.ch4Li2Text')}
              </li>
              <li>
                <strong>{t('cgu.ch4Li3Label')}</strong> {t('cgu.ch4Li3Text')}
              </li>
            </ul>
            <p>{t('cgu.ch4P1')}</p>
            <ul>
              <li>{t('cgu.ch4Li4')}</li>
              <li>{t('cgu.ch4Li5')}</li>
            </ul>
            <p>{t('cgu.ch4P2')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch5Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch5Intro')}</p>
            <ul>
              <li>{t('cgu.ch5Li1')}</li>
              <li>{t('cgu.ch5Li2')}</li>
              <li>{t('cgu.ch5Li3')}</li>
            </ul>
            <p>{t('cgu.ch5P1')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch6Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch6Intro')}</p>
            <ul>
              <li>{t('cgu.ch6Li1')}</li>
              <li>{t('cgu.ch6Li2')}</li>
              <li>{t('cgu.ch6Li3')}</li>
              <li>{t('cgu.ch6Li4')}</li>
              <li>{t('cgu.ch6Li5')}</li>
              <li>{t('cgu.ch6Li6')}</li>
            </ul>
            <p>{t('cgu.ch6P1')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch7Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch7P1')}</p>
            <p>{t('cgu.ch7P2')}</p>
            <p>{t('cgu.ch7P3')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch8Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch8P1')}</p>
            <p>{t('cgu.ch8P2')}</p>
            <p>{t('cgu.ch8P3')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch9Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch9P1')}</p>
            <p>{t('cgu.ch9P2Intro')}</p>
            <ul>
              <li>{t('cgu.ch9Li1')}</li>
              <li>{t('cgu.ch9Li2')}</li>
              <li>{t('cgu.ch9Li3')}</li>
              <li>{t('cgu.ch9Li4')}</li>
            </ul>
            <p>{t('cgu.ch9P3')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch10Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch10P1')}</p>
            <p>{t('cgu.ch10P2')}</p>
            <p>{t('cgu.ch10P3')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch11Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch11P1')}</p>
            <p>
              {t('cgu.ch11P2Before')} <a href="mailto:contact@vocaverb.com">contact@vocaverb.com</a> {t('cgu.ch11P2After')}
            </p>
            <p>{t('cgu.ch11P3')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch12Titre')}</h2>
          <div className="cgu-content">
            <p>{t('cgu.ch12Intro')}</p>
            <ul>
              <li>
                <strong>{t('cgu.ch12EmailLabel')}</strong> <a href="mailto:contact@vocaverb.com">contact@vocaverb.com</a>
              </li>
              <li>
                <strong>{t('cgu.ch12FormLabel')}</strong> <a href="/contact">{t('cgu.ch12FormLink')}</a>
              </li>
            </ul>
            <p>{t('cgu.ch12P1')}</p>
          </div>
        </section>

        <section className="cgu-section">
          <h2 className="section-title">{t('cgu.ch13Titre')}</h2>
          <div className="cgu-content">
            <p>
              {t('cgu.ch13P1Before')} <strong>{t('cgu.ch13Date')}</strong>.
            </p>
            <p>{t('cgu.ch13P2')}</p>
          </div>
        </section>

        <div className="cgu-footer">
          <p>
            © {new Date().getFullYear()} VocaVerb. {t('cgu.footerRights')}
          </p>
          <p>{t('cgu.footerMaj')}</p>
          <p>
            {t('cgu.footerContactBefore')} <a href="/mentions-legales">{t('cgu.footerMentionsLink')}</a> {t('cgu.footerOu')} <a href="/contact">{t('cgu.footerOrContactLink')}</a>.
          </p>
        </div>
      </div>
    </div>
  );
}
